import script from "./wInboundDetail.vue?vue&type=script&setup=true&lang=ts"
export * from "./wInboundDetail.vue?vue&type=script&setup=true&lang=ts"

import "./wInboundDetail.vue?vue&type=style&index=0&id=54fec8ee&lang=scss"

const __exports__ = script;

export default __exports__